import React, {SVGProps} from 'react';

import {ReactComponent as ImportIconClose} from '../../assets/icon-close.svg';
import {ReactComponent as ImportIconCopy} from '../../assets/icon-copy.svg';
import {ReactComponent as ImportIconFullScreenModeExpand} from '../../assets/icon-full-screen-mode-expand.svg';
import {ReactComponent as ImportIconOverflowHorizontal} from '../../assets/icon-overflow-horizontal.svg';
import {ReactComponent as ImportIconTextLanguageAlt} from '../../assets/icon-text-language-alt.svg';

import {ReactComponent as AgentSVGRaw} from '../../assets/icon-robot-service-member.svg';
import {ReactComponent as ToolSVGRaw} from '../../assets/icon-flash-bolt.svg';
import {ReactComponent as ChainSVGRaw} from '../../assets/icon-link-alt.svg';
import {ReactComponent as LLMSVGRaw} from '../../assets/icon-model.svg';
import {ReactComponent as PromptSVGRaw} from '../../assets/icon-forum-chat-bubble.svg';
import {ReactComponent as DownSVGRaw} from '../../assets/icon-chevron-down.svg';
import {ReactComponent as NextSVGRaw} from '../../assets/icon-chevron-next.svg';

type SVGIconProps = SVGProps<SVGElement>;
const updateIconProps = (props: SVGIconProps) => {
  return {
    width: 20,
    height: 20,
    ...props,
  };
};

export const IconClose = (props: SVGIconProps) => (
  <ImportIconClose {...updateIconProps(props)} />
);
export const IconCopy = (props: SVGIconProps) => (
  <ImportIconCopy {...updateIconProps(props)} />
);
export const IconFullScreenModeExpand = (props: SVGIconProps) => (
  <ImportIconFullScreenModeExpand {...updateIconProps(props)} />
);
export const IconOverflowHorizontal = (props: SVGIconProps) => (
  <ImportIconOverflowHorizontal {...updateIconProps(props)} />
);
export const IconTextLanguageAlt = (props: SVGIconProps) => (
  <ImportIconTextLanguageAlt {...updateIconProps(props)} />
);

const style = {
  verticalAlign: 'top',
  display: 'inline-block',
  margin: '1px 5px 0px 0px',
};

export const AgentSVG: React.FC = () => {
  return <AgentSVGRaw style={style} />;
};

export const ToolSVG: React.FC = () => {
  return <ToolSVGRaw style={style} />;
};

export const ChainSVG: React.FC = () => {
  return <ChainSVGRaw style={style} />;
};

export const LLMSVG: React.FC = () => {
  return <LLMSVGRaw style={style} />;
};

export const PromptSVG: React.FC = () => {
  return <PromptSVGRaw style={style} />;
};

export const DownSVG: React.FC = () => {
  return <DownSVGRaw style={style} />;
};

export const NextSVG: React.FC = () => {
  return <NextSVGRaw style={style} />;
};
